import { annotation } from './annotation';
import { auth } from './auth';
import { data } from './data';
import { dataHealth, health } from './health';
import { qbuilder } from './qbuilder';
import { stats } from './stats';
import { workflowMetrics } from './workflowMetrics';

export const api = {
    auth,
    data,
    health,
    dataHealth,
    qbuilder,
    annotation,
    stats,
    workflowMetrics,

    endpoints: {
        // Core
        dsReRun: 'api/qbuilder/rerun/',
        dsCount: 'api/ds-tasks/count',

        celery: 'api/celery/',
        annList: 'api/annotations/',
        annManage: 'api/annotations/manage',
        annRemove: 'api/annotations/',
        annVcRestore: 'api/annotations/restore',
        annProcess: 'api/annotations/processing',
        annStatus: 'api/annotations/status',
        annWarningCodes: 'api/annotations/warning_codes',
        annUsers: 'api/annotations/users',
        annStatistics: 'api/annotations/statistics',
        annReview: 'api/annotations/review',
        attrStatistics: 'api/data/annotations/statistics/attributes/',
        segmentStatistics: 'api/data/annotations/statistics/segments/',
        labelTree: 'api/data/annotations/tree/labels/',
        segmentTree: 'api/data/annotations/tree/segments/',

        information: 'api/information/',
        dataProject: 'api/data/projects/',
        project: 'api/projects/',
        projectLegend: 'api/projects_legends/',
        projectsHomeGraph: 'api/projects/home/graph/',
        projectMarket: 'api/projects_market/',
        projectMarketCategories: 'api/projects_market/categories/',

        // Data
        dsTasks: 'api/ds-tasks/',
        dsComplete: 'api/data/ds-tasks/complete',
        dsUpload: 'api/data/ds-tasks/upload/',

        dsMatched: 'api/data/ds-tasks/matched',
        anTasks: 'api/data/annotations/tasks/',
        annDetails: 'api/data/annotations/detail',
        annAttributes: 'api/data/annotations/attributes',
        annSearch: 'api/data/annotations/search',
        qbuilderEvaluate: 'api/data/qbuilder/evaluate',

        // Workflow
        workflowBatches: 'api/workflow/batches/',
        workflowRounds: 'api/workflow/rounds/',
        workflowAnnotationTasks: 'api/workflow/annotation-tasks/',
        workflowGuidelines: 'api/workflow/guidelines/',
        workflowGuidelineUpgrade: 'api/workflow/guidelines/:id/upgrade_guideline/',
        workflowRegistries: 'api/workflow/registries/',
        workflowInstructions: 'api/workflow/instructions/',
        workflowInstructionTagSuggestions: 'api/workflow/instructions/tag-suggestions/',
        // Workflow - CAT integration
        workflowCatProjects: 'api/workflow/rounds/cat_projects/',
        workflowCatJobs: 'api/workflow/rounds/cat_jobs/',
        workflowCatUsers: 'api/workflow/rounds/cat_users/',
        workflowCheckJobAvailability: 'api/workflow/rounds/check-job-availability/',
        workflowAsyncTasks: 'api/workflow/async-tasks/',
        workflowEventUsers: 'api/workflow/events/users/',
        workflowRoundsReportAvailableBatches: 'api/workflow/rounds-report/available-batches/',
        workflowRoundsReportExport: 'api/workflow/rounds-report/export/',
        workflowRoundsReportDownloadUrl: 'api/workflow/rounds-report/',
    },
};
